(function() {
  function initSeoChunks(section) {
    if (!section || section.dataset.seoChunksInitialized === 'true') return;

    var grid = section.querySelector('[data-seo-chunks-grid]');
    var arrow = section.querySelector('[data-seo-chunks-arrow]');

    if (!grid || !arrow) return;

    section.dataset.seoChunksInitialized = 'true';

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function updateArrow() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var visible = isMobile() && maxScroll > 2;

      arrow.setAttribute('data-visible', visible ? 'true' : 'false');
      arrow.setAttribute('aria-hidden', visible ? 'false' : 'true');
      arrow.tabIndex = visible ? 0 : -1;
    }

    arrow.addEventListener('click', function() {
      var maxScroll = grid.scrollWidth - grid.clientWidth;
      var scrollAmount = grid.clientWidth * 0.85;

      if (maxScroll <= 0) return;

      if (grid.scrollLeft >= maxScroll - 10) {
        grid.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    });

    grid.addEventListener('scroll', updateArrow, { passive: true });
    window.addEventListener('resize', updateArrow, { passive: true });

    updateArrow();

    window.setTimeout(updateArrow, 250);
  }

  function initAllSeoChunks() {
    document.querySelectorAll('[data-seo-chunks]').forEach(initSeoChunks);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSeoChunks);
  } else {
    initAllSeoChunks();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event || !event.target) return;

    event.target.querySelectorAll('[data-seo-chunks]').forEach(initSeoChunks);

    if (event.target.matches && event.target.matches('[data-seo-chunks]')) {
      initSeoChunks(event.target);
    }
  });
})();